export enum AddressType {
  shipper = 'shipper',
  consignee = 'consignee',
}
